import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from "@angular/forms";
import {trimInput} from "@myshared/utils";

@Component({
    selector: 'app-phonenumber-port-provider',
    templateUrl: './phonenumber-port-provider.component.html',
    standalone: false
})
export class PhonenumberPortProviderComponent implements OnInit {

  form: UntypedFormGroup;
  filteredProviders: any[];
  providers: any[];

  @Input()
  countryCode = 'DE';

  @Output()
  public onNext = new EventEmitter<string>();
  @Output()
  public onBack = new EventEmitter<void>();

  constructor(private http: HttpClient, private fb: UntypedFormBuilder) {
  }

  ngOnInit(): void {
    this.form = this.fb.group({
      selectedProvider: ['', Validators.required]
    });

    this.getProviders().then(p => {
      this.providers = p;
    });
  }

  searchProvider(event) {
    const filtered: any[] = [];

    for (const p of this.providers) {
      if (p.toLowerCase().indexOf(event.query.toLowerCase()) !== -1) {
        filtered.push(p);
      }
    }

    this.filteredProviders = filtered;
  }

  next() {
    if (this.form.invalid) return;
    const input = trimInput(this.form.get('selectedProvider').value);
    this.onNext.next(input);
  }

  back() {
    this.onBack.emit();
  }

  get formControl() {
    return this.form.get('selectedProvider') as UntypedFormControl;
  }

  private getProviders() {
    let providerFile = 'de_providers.json';
    if (this.countryCode !== 'DE') {
      providerFile = `${this.countryCode.toLowerCase()}_providers.json`;
    }
    return this.http.get<any>(`assets/${providerFile}`)
      .toPromise()
      .then(res => <any[]>res.data)
      .then(data => data);
  }

}
